import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

// 机器人数量及状态查询
export const robotTotalStatus = () => {
  return https().request('stat/robots/status', Method.GET, {}, ContentType.json)
}

// 累计任务数量及状态查询
export const taskNumber = () => {
  return https().request('stat/task/state', Method.GET, {}, ContentType.json)
}

// 累计时长数量与每日趋势
export const robotsOnline = (params: any) => {
  return https().request('stat/robots/online', Method.GET, params, ContentType.form)
}

// 累计里程与每日趋势
export const robotsOdometer = (params: any) => {
  return https().request('stat/robots/work/odometer', Method.GET, params, ContentType.form)
}

// 机器人工作时长趋势
export const robotsWorktimeTrend = (params: any) => {
  return https().request('stat/robots/worktime/trend', Method.GET, params, ContentType.form)
}

// 机器人工作时长占比
export const robotsworktimeRatio = (params: any) => {
  return https().request('stat/robots/worktime/ratio', Method.GET, params, ContentType.form)
}

// 楼宇配送次数对比
export const buildingDelivery= (params: any) => {
  return https().request('stat/task/building', Method.GET, params, ContentType.form)
}

// 获取协议
export const getAgreement = () => {
  return https().request('privacy', Method.GET, {}, ContentType.form)
}
